import AvailableSoon from "../../molecules/AvailableSoon";
import { useSelector } from "react-redux";
import { getTournamentData } from "../../../store/tournament/selectors";
import DoubleColumn from "../../molecules/DoubleColumn";
import {
  Card,
  CardBody,
  CardHeader,
  Heading,
  Image,
  Link,
  Text,
} from "@chakra-ui/react";
import useTournaments from "../../../utils/hooks/useTournaments";

export default function Tornei() {
  useTournaments();
  const tournaments = useSelector(getTournamentData);

  return (tournaments?.length === 0 ?? true) ||
    !tournaments?.some((tournament) => tournament.show) ? (
    <AvailableSoon />
  ) : (
    <DoubleColumn>
      {tournaments!.map((tournament) => {
        if (tournament.show) {
          return (
            <Card>
              <CardHeader>
                <Heading size={"md"}>{tournament.title}</Heading>
                <Heading size={"base"}>{tournament.area}</Heading>
                <Heading size={"base"} fontWeight="normal">
                  {tournament.data.split("-").reverse().join("/")}, h{" "}
                  {tournament.ora}
                </Heading>
              </CardHeader>
              <CardBody>
                <Text whiteSpace="pre-line">{tournament.description}</Text>
                {tournament.website && (
                  <Link href={tournament.website}>{tournament.website}</Link>
                )}
                {tournament.logoUrl && (
                  <Image
                    src={tournament.logoUrl}
                    w="100%"
                    maxH={"400px"}
                    objectFit="contain"
                    mt={2}
                  />
                )}
              </CardBody>
            </Card>
          );
        } else {
          return <></>;
        }
      })}
    </DoubleColumn>
  );
}
